// extracted by mini-css-extract-plugin
module.exports = {"ContactsTable":"ParentCompanyContactsTable_ContactsTable__1uyTo"};